module.exports = __webpack_public_path__ + "img/farm_equip.23e1903f.svg";